import moment from "moment"

const phoneValidation = (value) => {
  var restrictedPhoneNumbers = ["9920667766", "8069385555"];
  if (value.length < 10) {
    return {
      valid: false,
      mobile: value,
      errorMsg: "*Enter 10 digit mobile number",
    }
  }else if(restrictedPhoneNumbers.includes(value)) {
    return {
      valid: false,
      mobile: value,
      errorMsg: "*Enter valid mobile number",
    };
  }else {
    var regExp = /^[6-9]{1}[0-9]{9}$/.test(value)
    var errorMsg = ""
    if (regExp) {
      return {
        valid: true,
        mobile: value,
        errorMsg: errorMsg,
      }
    } else {
      return {
        valid: false,
        mobile: value,
        errorMsg: "*Enter valid mobile number",
      }
    }
  }
}
const ageValidation = (value, min, max) => {
  var regExp = /[a-zA-Z]/g
  var flag = regExp.test(value)
  var errorMsg = ""
  if (value === "") {
    return {
      valid: false,
      age: -3,
      errorMsg: errorMsg,
    }
  } else if (!flag) {
    var years = moment().diff(moment(value, "DD/MM/YYYY"), "years")
    var days = years === 0 && min === 0 ? moment().diff(moment(value, "DD/MM/YYYY"), "days") : 1
    // console.info('Days :', days)
    if (days > 0) {
      if (years > max || years < min) {
        years = -2
        errorMsg = `This option is available only for age between ${min} to ${max} years.`
      } else if (Math.sign(years) === -1) {
        years = -1
        errorMsg = "*Enter valid date of birth"
      } else if (isNaN(parseFloat(years))) {
        years = -1
        errorMsg = "*Enter valid date of birth"
      }
      return {
        valid: true,
        age: years,
        errorMsg: errorMsg,
      }
    } else {
      years = -2
      errorMsg = `This option is available only for age between ${min} to ${max} years.`
      return {
        valid: true,
        age: years,
        errorMsg: errorMsg,
      }
    }
  } else {
    return {
      valid: false,
      age: -1,
      errorMsg: errorMsg,
    }
  }
}

const emailValidation = (value) => {
  // Restricted email addresses
  var restrictedMail = ["bolescalation@icicilife.com", "lifeline@icicilife.com","buyonline@icicilife.com"];

  // Email format validation
  var regExp = /^(?=.{5,50}$)(?!.*?[._-]{2})[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){0,1}\.[a-zA-Z]{2,12}$/
  var errorMsg = ""

  const isValidEmail = regExp.test(value);

  if (restrictedMail.includes(value)) {
    return {
      valid: false,
      email: value,
      errorMsg: "*Enter valid email id",
    };
  }  
  return {
    valid: isValidEmail,
    email: value,
    errorMsg: isValidEmail ? "" : "*Enter valid email id",
  }
}

const getKeyByValueOfJson = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value)
}

const getValueByKeyOfJson = (object, keyVal) => {
  for (var key in object) {
    if (key == keyVal) return object[key]
  }
  return ""
}

export { phoneValidation, ageValidation, emailValidation, getKeyByValueOfJson, getValueByKeyOfJson }
